export function identifyFile(file) {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onerror = function () {
            reject('Unknown registration file');
        };
        reader.onload = function (event) {
            var buffer = event.target.result;
            var view = new Uint8Array(buffer);
            var left = 0, valid = true;
            for (var i in view) {
                var c = view[i];
                if (left == 0) {
                    if (c >= 128) {
                        var j;
                        for (j = 64; (j > 2) && (c & j); j = j >> 1) {
                            ++left;
                        }
                        if (j == 2) {
                            valid = false;
                            break;
                        }
                    }
                }
                else {
                    if ((c & 0x80) != 0x80) {
                        valid = false;
                        break;
                    }
                    --left;
                }
            }
            resolve((valid && (left == 0)) ? 'UTF-8' : 'ISO8859-1');
        };
        reader.readAsArrayBuffer(file);
    });
}
// This will parse a delimited string into an array of
// arrays. The default delimiter is the comma, but this
// can be overriden in the second argument.
export function CSVToArray(strData, strDelimiter) {
    // Check to see if the delimiter is defined. If not,
    // then default to comma.
    strDelimiter = (strDelimiter || ",");
    // Create a regular expression to parse the CSV values.
    var objPattern = new RegExp((
    // Delimiters.
    "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
        // Quoted fields.
        "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
        // Standard fields.
        "([^\"\\" + strDelimiter + "\\r\\n]*))"), "gi");
    // Create an array to hold our data. Give the array
    // a default empty first row.
    var arrData = [[]];
    // Create an array to hold our individual pattern
    // matching groups.
    var arrMatches = null;
    // Keep looping over the regular expression matches
    // until we can no longer find a match.
    while (arrMatches = objPattern.exec(strData)) { //eslint-disable-line
        // Get the delimiter that was found.
        var strMatchedDelimiter = arrMatches[1];
        // Check to see if the given delimiter has a length
        // (is not the start of string) and if it matches
        // field delimiter. If id does not, then we know
        // that this delimiter is a row delimiter.
        if (strMatchedDelimiter.length &&
            (strMatchedDelimiter != strDelimiter)) {
            // Since we have reached a new row of data,
            // add an empty row to our data array.
            arrData.push([]);
        }
        // Now that we have our delimiter out of the way,
        // let's check to see which kind of value we
        // captured (quoted or unquoted).
        let strMatchedValue;
        if (arrMatches[2]) {
            // We found a quoted value. When we capture
            // this value, unescape any double quotes.
            strMatchedValue = arrMatches[2].replace(new RegExp("\"\"", "g"), "\"");
        }
        else {
            // We found a non-quoted value.
            strMatchedValue = arrMatches[3];
        }
        // Now that we have our value string, let's add
        // it to the data array.
        arrData[arrData.length - 1].push(strMatchedValue);
    }
    // Return the parsed data.
    return (arrData);
}
